import { useAppStore } from '../stores/AppStore';

export default function ExitButton({ siteLink }) {
    const { setShowExitModal } = useAppStore(state => state);

    const handleExit = (e) => {
        e.preventDefault();

        setShowExitModal(true);
    }

    return (
        <>
            <div 
                className="text-dusk text-xs text-center font-normal font-['Montserrat'] leading-none cursor-pointer"
                onClick={handleExit}
            >
                <div className="w-[193px] h-[38px] relative px-4 mr-0 md:mr-10 bg-white border border-clay rounded-full justify-center items-center gap-2.5 inline-flex flex-shrink-0 hover:border-lava hover:text-lava hover:bg-lava/20 transition-all duration-300">
                    <span className="text-sm">👋</span>
                    Exit system builder
                </div>
            </div>
        </>
    )
}